export default __webpack_public_path__ + "static/media/carhartt.37f52ce8.jpg";